export interface ApiDevice {
    id: string; // "330",
    imei: string; // "356321080870280",
    data: string; // "{\"model\":\"SM-A320F\"}",
    account_id?: string; // "654"
}

export interface Device {
    id: number; // "330",
    imei: string; // "356321080870280",
    data: Object; // "{\"model\":\"SM-A320F\"}",
    account_id?: number; // "654"
}

export function ConvertApiDevice(d: ApiDevice): Device {
    const res: Device = {
        id: 0,
        imei: d.imei,
        data: {},
        account_id: null,
    };
    try {
        res.id = parseInt(d.id, 10);
        res.account_id = d.account_id ? parseInt(d.account_id, 10) : null;
        res.data = JSON.parse(d.data);
    } catch (err) {
        console.error('could not parse api device', err);
    }

    return res;
}

export interface Standardization {
    id: string; // "42",
    calibration_date: string; // "1539677586",
    calibration_expiry_date: string; // "1571213586",
    model: string; // "SM-A320F",
    android_version: string; // "8.0.0",
    build_number: string; // "samsung/a3y17ltexx/a3y17lte:8.0.0/R16NW/A320FXXU4CRH1:user/release-keys",
}



// WEBPACK FOOTER //
// ./src/app/models/device.ts